import { Navigate } from "react-router-dom";
import { useWorkspaces } from "../api/hooks/useWorkspaces";
import { wsHome } from "../lib/paths";
import { Spinner } from "../ui/Spinner";

// Redirects / to the personal workspace or first workspace in the list.
// Falls back to /sign-in if the user has no workspaces.
export function RootRedirect(){
  const { data: workspaces, isLoading } = useWorkspaces();

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!workspaces || workspaces.length === 0) {
    return <Navigate to="/sign-in" replace />;
  }

  const personal = workspaces.find((w) => w.isPersonal) ?? workspaces[0];
  return <Navigate to={wsHome(personal.slug)} replace />;
}
